import OrmModel from '~/models/abstracts/base/OrmModel'

export default class Pivot extends OrmModel {
  //
}
